export class PolicyDetails {
    policyId?: number;
    policyNumber?: string;
    productTemplateId: number;
    inceptionDate: string;
    customerId: number;
    sponsorId: number;
    expiryDate?: string;
}
